var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "w-full" },
    [
      _vm._t("header-content"),
      _vm._v(" "),
      _vm._t("body-content"),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("label", { attrs: { for: "phone" } }, [
            _vm._v(_vm._s(_vm.step.label)),
          ]),
          _vm._v(" "),
          _c("Multiselect", {
            staticClass: ".multiselect__option--highlight",
            attrs: {
              options: _vm.step.valueList,
              searchable: false,
              "close-on-select": false,
              "preserve-serarch": true,
              multiple: true,
              placeholder: "Select all that apply",
              selectLabel: "",
              deselectLabel: "Click to remove",
            },
            model: {
              value: _vm.inputData,
              callback: function ($$v) {
                _vm.inputData = $$v
              },
              expression: "inputData",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showButton
        ? _c("ButtonSection", {
            attrs: {
              inputValid: _vm.inputData.length,
              order: _vm.order,
              buttonText: _vm.step.buttonText,
              backButtonText: _vm.step.backButtonText,
              exitButtonText: _vm.step.exitButtonText,
            },
            on: {
              progress: function ($event) {
                return _vm.$emit("progress")
              },
              "hide-modal": function ($event) {
                return _vm.$emit("hide-modal")
              },
              back: function ($event) {
                return _vm.$emit("back")
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._t("login"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }